module.exports = "/static/assets/6cf121d4d915bb7d0663a73aaaa4d7b4.png";